import React, {useMemo} from "react";
import {connect} from "react-redux";
import PricingContext, {usePricingContext} from "../PricingContext";
import {setPricingCatalogs, setPricingCustomGroupNames} from "../pricingActions";


const PricingDetailsInputs = (props) => {

  const {pricingCustomGroupNames, setPricingCustomGroupNames, featureGroups, pricingCatalogs, setPricingCatalogs} = props;

  const {routeParams} = usePricingContext(PricingContext);
  const {paramsGroupName, paramsCatalogName} = routeParams;

  const activeCatalog = pricingCatalogs.find(catalog => catalog.isActive);

  const onGroupNameChange = (event) => {
    setPricingCustomGroupNames(paramsGroupName, event.target.value);
  }

  const onCatalogNameChange = (event) => {
    setPricingCatalogs(pricingCatalogs.map(catalog => {
      if (catalog.isActive) {
        catalog.newCustomName = event.target.value;
        if (!catalog.needToSaveCatalog) {
          catalog.needToUpdateCatalog = event.target.value !== catalog.name;
        }
      }
      return catalog
    }));
  }

  const inputGroupNameValue = useMemo(() => {
    if (!featureGroups.length || !paramsGroupName) {
      return ""
    }
    if (pricingCustomGroupNames[paramsGroupName]) {
      return pricingCustomGroupNames[paramsGroupName]
    }
    const featureGroup = featureGroups.find(fg => fg.groupName === paramsGroupName);
    if (featureGroup) {
      return featureGroup.customDisplayName || featureGroup.groupName
    }
    return ""
  }, [featureGroups, pricingCustomGroupNames, paramsGroupName]);

  return (
    <div className="pr-details__inputs">
      <div className="mb-1">
        <label htmlFor="groupNameInput" className="ui-input3-title">Group Name</label>
        <input placeholder=""
               id="groupNameInput"
               type="text"
               className={"radius-5 ui-input ui-input--gray4 ui-input--gray4--small ui-input--gray4--small--pr"
                 + (paramsGroupName ? "" : " ui-input--gray4--disabled")}
               onChange={onGroupNameChange}
               value={inputGroupNameValue}/>
      </div>
      <div className="mb-1">
        <label htmlFor="catalogNameInput" className="ui-input3-title">Catalog Name</label>
        <input placeholder=""
               type="text"
               value={activeCatalog ? activeCatalog.newCustomName : ""}
               onChange={onCatalogNameChange}
               id="catalogNameInput"
               className="radius-5 ui-input ui-input--gray4 ui-input--gray4--small ui-input--gray4--small--pr"/>
      </div>
      <span className="font--14 color-light inactive">
        <span className="bold">Default Slab Size:</span> 120 X 60
      </span>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {pricingCustomGroupNames, pricingCatalogs} = store.pricingState;
  const {loading, featuresGroups} = store.projectScopeNew;

  return {
    pricingCustomGroupNames,
    featureGroups: loading ? [] : featuresGroups,
    pricingCatalogs,
  };
};

const mapDispatchToProps = {
  setPricingCustomGroupNames,
  setPricingCatalogs,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingDetailsInputs);
